// gloss
export const buildBrandLookupQuery = (identifiers: {
  uuid?: string;
  brandID?: string | number | null;
  code?: string;
}) => {
  const query: { uuid?: string; brandID?: number; code?: string } = {};

  if (identifiers.uuid) {
    query.uuid = identifiers.uuid;
  }

  // why: brandID from storage is often a non-numeric code; sending Number() of it as NaN gets
  // why: the whole lookup request rejected server-side, so drop invalid brandIDs instead.
  if (identifiers.brandID != null && identifiers.brandID !== '') {
    const numericBrandID = Number(identifiers.brandID);

    if (Number.isFinite(numericBrandID)) {
      query.brandID = numericBrandID;
    }
  }

  if (identifiers.code) {
    query.code = identifiers.code;
  }

  return query;
};
